import React, { FC, ComponentProps } from "react";
import { cls } from "@wss/cls";

const Image: FC<ComponentProps<"img">> = ({ className, alt, ...rest }) => (
  <div className="p-1.5 border border-gray-300 border-solid rounded-lg shadow-sm">
    <img
      className={cls(
        "shrink-0 group-hover:opacity-75 group-active:opacity-75",
        className,
      )}
      alt={alt}
      {...rest}
    />
  </div>
);

export default Image;
